module.exports = __webpack_public_path__ + "german.35ef1984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/german.png
// module id = 1497
// module chunks = 0